"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicStressPower = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var TectonicStressPower = (function (_super) {
    __extends(TectonicStressPower, _super);
    function TectonicStressPower() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.TECTONIC_STRESS_POWER,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            cost: 18,
            productionBox: Units_1.Units.of({ energy: 3 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 2); }),
            metadata: {
                cardNumber: '145',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(3); });
                }),
                description: 'Requires 2 Science tags. Increase your Energy production 3 steps.',
                victoryPoints: 1,
            },
        }) || this;
    }
    TectonicStressPower.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 3);
        return undefined;
    };
    TectonicStressPower.prototype.getVictoryPoints = function () {
        return 1;
    };
    return TectonicStressPower;
}(Card_1.Card));
exports.TectonicStressPower = TectonicStressPower;
//# sourceMappingURL=TectonicStressPower.js.map